export default __webpack_public_path__ + "static/media/supply-demand-goods.728b3f2c.png";